<div [formGroup]="form" class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <div class="flex gap-2 align-items-center">
      <label for="fixLinkLite" class="font-semibold w-full">{{
        "fault_allocation.fault_lists.faults.translations.form.fix_link_lite" | translate
      }}</label>
      <app-svg-icon
        class="flex"
        iconName="info-circle"
        tooltipPosition="bottom"
        iconSize="xs"
        [pTooltip]="translate.instant('fault_allocation.fault_lists.faults.fixLink_hint')"
        iconColor="secondary"
      ></app-svg-icon>
    </div>

    <input id="fixLinkLite" formControlName="fixLinkLite" pInputText autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <div class="flex gap-2 align-items-center">
      <label for="fixLinkExpert" class="font-semibold w-full">{{
        "fault_allocation.fault_lists.faults.translations.form.fix_link_expert" | translate
      }}</label>
      <app-svg-icon
        class="flex"
        iconName="info-circle"
        tooltipPosition="bottom"
        iconSize="xs"
        [pTooltip]="translate.instant('fault_allocation.fault_lists.faults.fixLink_hint')"
        iconColor="secondary"
      ></app-svg-icon>
    </div>
    <input id="fixLinkExpert" formControlName="fixLinkExpert" pInputText autocomplete="off" />
  </div>
  <div class="flex flex-column gap-2 mb-6">
    <label for="faultText" class="font-semibold w-full"
      >{{ "fault_allocation.fault_lists.faults.translations.form.fault_text" | translate }}*</label
    >
    <textarea
      id="faultText"
      formControlName="faultText"
      [autoResize]="true"
      rows="3"
      maxlength="1000"
      pInputTextarea
    ></textarea>
    @if (form.controls.faultText.hasError("maxlength")) {
      <small class="p-error">{{
        "fault_allocation.fault_lists.faults.translations.form.fault_text_too_long" | translate
      }}</small>
    }
  </div>
  <div class="flex flex-column gap-2 mb-6">
    <label for="languageCode" class="font-semibold w-full"
      >{{ "fault_allocation.fault_lists.faults.translations.form.language" | translate }}*</label
    >
    <p-select class="w-full" formControlName="languageCode" [options]="languages"></p-select>
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
  </div>
</div>
